import { FolderMultipleIcon } from './FolderMultipleIcon';

/**
 * author: Austin Andrews
 * id 7116841C-C243-4A44-8C68-267048AAF939
 * name folder-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-multiple.svg
 * tags
 * - Files / Folders 
 */
export const FoldersIcon = FolderMultipleIcon;
export default FoldersIcon